<div class="container mb-pdp-tab-content mb-product-data-images-tab"
     data-cy="mb-product-data-images-tab"
     *ngIf="product$ | async as product">

  <div *ngIf="imageFigures$ | async as imageFigures"
       class="mb-pdp-tab-wrapper mb-data-images-wrapper">
    <div class="row no-gutters">
      <div class="col-12 mb-data-image-headline-text"
           data-cy="mb-data-image-heading">
        {{'mbProductTabs.productDataImagesFor' | mbTranslate}}
        <span class="mb-data-image-text-bold" [innerHTML]="productName | safeHtml"> </span>
      </div>
    </div>
    <div class="row no-gutters">
      <div *ngIf="imageFigures?.dataImageFigures" class="col-12">
        <ng-container *ngFor="let imageFigure of sortBySortOrder(imageFigures?.dataImageFigures); index as i">
          <div *ngIf="imageFigure?.title" class="mb-data-image-subtext mb-data-image-text-bold"
               [attr.data-cy]="'mb-image-figure-title-' + i"
               [innerHTML]="imageFigure?.title  | safeHtml">

          </div>
          <div *ngIf="imageFigure?.longDescription"
               class="mb-data-image-subtext"
               [attr.data-cy]="'mb-image-figure-description-' + i"
               [innerHTML]="imageFigure?.longDescription  | safeHtml">

          </div>
          <ng-container *ngIf="imageFigure?.imageGroups.length">
            <ng-container *ngFor="let imageGroup of imageFigure?.imageGroups; index as imageGroupIndex">

              <div *ngIf="imageGroup?.headline"
                   class="mb-data-image-subtext mb-data-image-text-bold"
                   [attr.data-cy]="'mb-image-group-headline-' + imageGroupIndex"
                   [innerHTML]="imageGroup?.headline | safeHtml">
              </div>

              <ng-container *ngIf="imageGroup?.images">
                <div class="row no-gutters mb-image-headline-image">
                  <ng-container *ngFor="let image of imageGroup?.images; index as imageIndex">

                    <div
                      [ngClass]="[imageGroup.images.length === 2 ? 'col-6 col-md-4' : imageGroup.images.length === 1 ? 'col-12 col-md-4' : 'col-4', 'd-grid pr-3']">
                      <div class="align-self-end image-wrapper cursor-pointer"
                           (click)="openDialog(image, imageGroup.images, imageFigure.longDescription)">
                        <img [src]="image.url"
                             class="img-responsive"
                             title="Product Image Figure"
                             alt="Product Image Figure"
                             aria-label="Product Image Figure"
                             [attr.data-cy]="'mb-product-data-image-' + imageIndex"/>
                        <span>
                          <img src="assets/icons/svg/icon_search_plus.svg"
                               title="View details"
                               alt="View details"
                               aria-label="View details"
                               [attr.data-cy]="'mb-image-view-details-' + imageIndex"/>
                          {{ 'mbProductTabs.viewDetails' | mbTranslate }}
                        </span>
                      </div>
                      <div *ngIf="image?.headline"
                           class="align-self-start mb-data-image-headline mb-3 mb-image-headline"
                           [attr.data-cy]="'mb-image-headline-' + imageIndex"
                           [innerHTML]="image?.headline  | safeHtml">

                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
